import { useCallback } from "react";
import formatBudgetData from "../../../helpers/Budget/formatBudget";
import useAuthenticatedQuery from "../../useAuthenticatedQuery";
import useCurrentUser from "../../useCurrentUser";
import useFinancialsConfiguration from "../../useFinancialsConfiguration";
import budgetKeys from "./budgetKeys";
import fetchBudgetHandler from "./handlers/fetchBudgetHandler";
/**
 * Query hook to fetch budget
 */
const useBudgetById = (id) => {
  const { data: currentUser } = useCurrentUser();
  const { data: financialsConfiguration } = useFinancialsConfiguration();

  const authenticatedResponse = useAuthenticatedQuery({
    queryKey: budgetKeys.byId(id),
    enabled: !!id,
    queryFn: ({ signal }) => fetchBudgetHandler(signal, id),
    select: (data) => {
      return formatBudgetData(data, financialsConfiguration, currentUser);
    },
    onError: (error) => {
      console.error("useBudgetById: Error fetching budget", error);
    },
  });

  const refetchBudget = useCallback(async () => {
    await authenticatedResponse.refetch();
  }, [authenticatedResponse]);

  const { data: budgetData, isLoading: budgetLoading } = authenticatedResponse;

  return {
    budgetLoading,
    budgetData,
    refetchBudget,
  };
};

export default useBudgetById;
